import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { QuestionnaireSection } from "./QuestionnaireSection";
import { CLINIC_COLORS, BTN_GRADIENT } from "./theme";

// Matches the mockup:
// - No outer wrapping card; sections + individual question cards laid out in a vertical stack
// - Back (ghost, left) + primary pill (right) in a single footer row
export function QuestionnaireStep({
  questionnaire,
  updateQuestionnaire,
  takesInterferingMeds,
  isQuestionnaireComplete,
  onBack,
  onContinue,
  error = "",
}) {
  const { t } = useTranslation();
  const complete = isQuestionnaireComplete();

  return (
    <div className="animate-fade-in">
      {error && (
        <div
          className="text-sm p-4 rounded-xl mb-6"
          style={{ background: CLINIC_COLORS.warmAmberBg, color: CLINIC_COLORS.warmAmber }}
          data-testid="questionnaire-error"
        >
          {error}
        </div>
      )}

      <QuestionnaireSection
        questionnaire={questionnaire}
        updateQuestionnaire={updateQuestionnaire}
        takesInterferingMeds={takesInterferingMeds}
      />

      <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-10">
        <button
          type="button"
          onClick={onBack}
          data-testid="questionnaire-back-btn"
          className="order-2 md:order-1 px-8 py-3 font-semibold rounded-full transition-all inline-flex items-center gap-2"
          style={{ color: CLINIC_COLORS.primary, background: "transparent" }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#ebeef3")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <ArrowLeft className="w-4 h-4" />
          {t("dashboard.backToSymptoms") || t("common.back") || "Tagasi"}
        </button>
        <button
          type="button"
          data-testid="continue-to-labs-btn"
          onClick={onContinue}
          disabled={!complete}
          className="order-1 md:order-2 w-full md:w-auto px-12 py-4 text-white font-bold rounded-full shadow-lg transition-all hover:scale-[1.02] active:scale-95 inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          style={{ background: BTN_GRADIENT, boxShadow: "0 8px 20px rgba(0,101,141,0.25)" }}
        >
          {t("dashboard.continueToLabs")}
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
